import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from 'antd';
import styles from './CompactTable.module.scss';
export const CompactTable = ({ columns, dataSource, className = '', compact = true, bordered = true, pagination = false, scroll = { x: 400 }, ...props }) => {
    const tableClassName = `
    ${styles.compactTable} 
    ${compact ? styles.ultraCompact : styles.semiCompact}
    ${className}
  `.trim();
    return (_jsx("div", { className: styles.wrapper, children: _jsx(Table, { ...props, className: tableClassName, columns: columns, dataSource: dataSource, size: 'small', bordered: bordered, pagination: pagination, scroll: scroll }) }));
};
